const PRICES = {
  priceMin: [1000, 2000, 5000, 10000, 15000, 20000, 30000],
  priceMax: [25000, 30000, 40000, 50000, 100000, 200000],
};
export default PRICES;
